import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import Home from './pages/Home';
import About from './pages/About';
import VisaServices from './pages/VisaServices';
import TourPackages from './pages/TourPackages';
import Flights from './pages/Flights';
import Hotels from './pages/Hotels';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import VisaDetail from './pages/VisaDetail';
import DestinationDetail from './pages/DestinationDetail';
import ThailandDMC from './pages/ThailandDMC';
import B2BLogin from './pages/B2BLogin';
import B2BRegister from './pages/B2BRegister';
import B2BDashboard from './pages/B2BDashboard';
import { Toaster } from './components/ui/sonner';
import './App.css';

const ScrollToTop = () => {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
};

const Layout = ({ children }) => {
  const location = useLocation();
  const hideChrome = location.pathname.startsWith('/admin') || location.pathname.startsWith('/b2b');

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {!hideChrome && <Header />}
      <main className="flex-1">{children}</main>
      {!hideChrome && <Footer />}
      {!hideChrome && <FloatingButtons />}
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/visa-services" element={<VisaServices />} />
            <Route path="/visa/:slug" element={<VisaDetail />} />
            <Route path="/tour-packages" element={<TourPackages />} />
            <Route path="/destinations/:slug" element={<DestinationDetail />} />
            <Route path="/flights" element={<Flights />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/thailand-dmc" element={<ThailandDMC />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/b2b" element={<B2BLogin />} />
            <Route path="/b2b/login" element={<B2BLogin />} />
            <Route path="/b2b/register" element={<B2BRegister />} />
            <Route path="/b2b/dashboard" element={<B2BDashboard />} />
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
